import { render } from "./PhoneUs.vue?vue&type=template&id=4a54ac18&scoped=true"
import script from "./PhoneUs.vue?vue&type=script&lang=js"
export * from "./PhoneUs.vue?vue&type=script&lang=js"

import "./PhoneUs.vue?vue&type=style&index=0&id=4a54ac18&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a54ac18"]])

export default __exports__